/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AffiliateTeamAllOfTrading
 */
export interface AffiliateTeamAllOfTrading {
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfTrading
   */
  totalEarned?: number
  /**
   *
   * @type {boolean}
   * @memberof AffiliateTeamAllOfTrading
   */
  isWeakTeam?: boolean
  /**
   *
   * @type {number}
   * @memberof AffiliateTeamAllOfTrading
   */
  members?: number
}

export function AffiliateTeamAllOfTradingFromJSON(json: any): AffiliateTeamAllOfTrading {
  return AffiliateTeamAllOfTradingFromJSONTyped(json, false)
}

export function AffiliateTeamAllOfTradingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AffiliateTeamAllOfTrading {
  if (json === undefined || json === null) {
    return json
  }
  return {
    totalEarned: !exists(json, 'totalEarned') ? undefined : json['totalEarned'],
    isWeakTeam: !exists(json, 'isWeakTeam') ? undefined : json['isWeakTeam'],
    members: !exists(json, 'members') ? undefined : json['members'],
  }
}

export function AffiliateTeamAllOfTradingToJSON(value?: AffiliateTeamAllOfTrading | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    totalEarned: value.totalEarned,
    isWeakTeam: value.isWeakTeam,
    members: value.members,
  }
}
